(() => {
  const focusableSelector = 'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])';
  const mediaQuery = window.matchMedia('(min-width: 60rem)');
  const isDesktop = () => mediaQuery.matches;

  document.querySelectorAll('.header-main').forEach((header) => {
    const menuToggle = header.querySelector('.menu-toggle');
    const collapsable = header.querySelector('.header-collapsable');

    const fixedScrollDesktop = !!parseInt(header.dataset.fixedScrollDesktop, 10);
    const fixedScrollMobile = !!parseInt(header.dataset.fixedScrollMobile, 10);
    const hideOnScrollDownDesktop = !!parseInt(header.dataset.hideScrollDownDesktop, 10);
    const hideOnScrollDownMobile = !!parseInt(header.dataset.hideScrollDownMobile, 10);

    let startHeight = 0;
    let height = 0;
    let lastScrollY = window.scrollY;
    let scrollingUpActive = false;
    let scrollingDownActive = false;

    const calculateStartHeight = () => {
      startHeight = 0;

      let node = header.previousElementSibling;
      while (node) {
        startHeight += node.offsetHeight || 0;
        node = node.previousElementSibling;
      }

      if(document.querySelector('#wpadminbar')){
        startHeight += document.querySelector('#wpadminbar').offsetHeight;
      }

      header.style.setProperty('--start-height', startHeight + 'px');
    }

    const addFixedOffsetsRecursively = (element) => {
      let offset = 0;
      const style = window.getComputedStyle(element);

      if (style.position === 'fixed') {
        if (style.bottom !== 'auto' && style.bottom !== '' && style.bottom !== '0px') {
          const rect = element.getBoundingClientRect();
          if (rect.height > 0 && style.display !== 'none') {
            const visible = Math.max(0, Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0));
            offset += visible;

            if(document.querySelector('#wpadminbar')){
              const adminBarHeight = document.querySelector('#wpadminbar').offsetHeight;
              if(offset == adminBarHeight){
                offset -= adminBarHeight
              }
            }
          }
        }
        return offset;
      }

      Array.from(element.children).forEach(child => {
        offset += addFixedOffsetsRecursively(child);
      });

      return offset;
    }

    const calculateFixedOffset = () => {
      let offset = 0;
      let node = header.previousElementSibling;

      while (node) {
        offset += addFixedOffsetsRecursively(node);
        node = node.previousElementSibling;
      }

      if(document.querySelector('#wpadminbar')){
        offset += document.querySelector('#wpadminbar').offsetHeight;
      }

      offset = Math.floor(offset);

      header.style.setProperty('--fixed-offset', offset + 'px');
    }

    const toggleMenu = () => {
      if(header.classList.contains('menu-open')){
        closeMenu();
      }else{
        openMenu();
      }
    }

    const openMenu = () => {
      header.classList.add('menu-open');
      menuToggle.setAttribute('aria-expanded', 'true');

      collapsable.querySelectorAll(focusableSelector).forEach((element, index) => {
        element.removeAttribute('inert');
      });

      header.addEventListener('keydown', trapFocus);
    }

    const closeMenu = () => {
      header.classList.remove('menu-open');
      
      if(!isDesktop()){
        menuToggle.setAttribute('aria-expanded', 'false');
      }

      collapsable.querySelectorAll(focusableSelector).forEach((element) => {
        if(!isDesktop()){
          element.setAttribute('inert', '');
        }else{
          element.removeAttribute('inert');
        }
      });

      header.removeEventListener('keydown', trapFocus);
    }

    const updateHeaderClass = () => {
      if(isDesktop()){
        header.classList.remove('mid');
      }else{
        header.classList.add('mid');
      }
    }

    const updateHeaderHeight = () => {
      header.classList.add('transition-none!', 'resizing');
      height = header.offsetHeight;
      document.documentElement.style.setProperty('--header-main-height', height + 'px');
      document.documentElement.style.setProperty('--header-main-small-height', (isDesktop() ? height - 24 : height) + 'px');
      header.classList.remove('transition-none!', 'resizing');
    }

    const updateScrollStatus = () => {
      const offset = 10;
      const scrollY = window.scrollY;

      if (scrollY > startHeight) {
        if (!header.classList.contains('scrolling')) {
          header.classList.add('transition-none');
          setTimeout(() => {
            header.classList.remove('transition-none');
          }, 250);
        }

        header.classList.add('scrolling');
        if (scrollY < lastScrollY) {
          if (!scrollingUpActive && (lastScrollY - scrollY) > offset) {
            header.classList.add('scrolling-up');
            header.classList.remove('scrolling-down');
            if((isDesktop() && fixedScrollDesktop) || (!isDesktop() && fixedScrollMobile)){
              document.documentElement.style.setProperty('--current-header-main-height', 'var(--header-main-small-height)');
            }else{
              document.documentElement.style.setProperty('--current-header-main-height', '0px');
            }
            scrollingUpActive = true;
            scrollingDownActive = false;
          }

          if(scrollingUpActive){
            lastScrollY = scrollY;
          }
        } else if (scrollY > lastScrollY) {
          if (!scrollingDownActive && (scrollY - lastScrollY) > offset) {
            header.classList.add('scrolling-down');
            header.classList.remove('scrolling-up');
            if((isDesktop() && hideOnScrollDownDesktop) || (!isDesktop() && hideOnScrollDownMobile)){
              document.documentElement.style.setProperty('--current-header-main-height', '0px');
            }else{
              document.documentElement.style.setProperty('--current-header-main-height', 'var(--header-main-small-height)');
            }
            scrollingDownActive = true;
            scrollingUpActive = false;
          }
          
          if(scrollingDownActive){
            lastScrollY = scrollY;
          }
        }
      } else {
        if (header.classList.contains('scrolling')) {
          header.classList.add('transition-none');
          setTimeout(() => {
            header.classList.remove('transition-none');
          }, 250);
        }

        header.classList.remove('scrolling');
        header.classList.remove('scrolling-up');
        header.classList.remove('scrolling-down');
        scrollingUpActive = false;
        scrollingDownActive = false;
        lastScrollY = scrollY;
        document.documentElement.style.setProperty('--current-header-main-height', 'var(--header-main-height)');
      }
    }
    
    const trapFocus = (e) => {
      const focusable = header.querySelectorAll(focusableSelector);
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (e.key === 'Tab') {
        if (e.shiftKey) {
          if (document.activeElement === first) {
            last.focus();
            e.preventDefault();
          }
        } else {
          if (document.activeElement === last) {
            first.focus();
            e.preventDefault();
          }
        }
      } else if (e.key === 'Escape') {
        closeMenu();
        menuToggle.focus();
      }
    };

    let scrollRAF = null;
    window.addEventListener('scroll', () => {
      if (scrollRAF) return;
      scrollRAF = requestAnimationFrame(() => {
        updateScrollStatus();
        setTimeout(calculateFixedOffset, 200);
        scrollRAF = null;
      });
    }, { passive: true });

    mediaQuery.addEventListener('change', () => {
      closeMenu();
      updateHeaderClass();
      calculateStartHeight();
      setTimeout(calculateFixedOffset, 200);
      updateHeaderHeight();

      setTimeout(() => {
        calculateStartHeight();
        calculateFixedOffset();
        updateHeaderHeight();
      }, 300);
    });

    menuToggle.addEventListener('click', (event) => {
      event.preventDefault();
      toggleMenu();
    });

    document.addEventListener('DOMContentLoaded', () => {
      closeMenu();
      setTimeout(calculateFixedOffset, 200);
      updateHeaderHeight();
      calculateStartHeight();
      updateHeaderClass();
    });
  });
})();